import { useSession } from '@/contexts/LitSessionProvider';
import { updateDbCloudWallet } from '@/lib/db/DBCloudWalletHelpers';
import { useUserCloudQuery } from '../onboarding/useReferralQuery';
import useMultiTokenData from '../explore/useMultiTokenData';
import { queryClient } from '@/pages/_app';
export const useRecentToken = () => {
  const {
    PKP
  } = useSession();
  const {
    data: recentTokenData
  } = useUserCloudQuery();
  const handleSaveRecent = async ({
    tokenData
  }: {
    tokenData: any;
  }) => {
    if (!tokenData) {
      return;
    }
    let saved = recentTokenData?.data?.recent_tokens ?? [];
    saved.unshift({
      token: tokenData
    });
    saved = saved.filter((token, index, self) => index === self.findIndex(t => t.token?.address === token.token?.address && t.token?.networkId === token.token?.networkId));
    await updateDbCloudWallet({
      eth_address: PKP?.ethAddress,
      recent_tokens: JSON.stringify(saved)
    });
    queryClient.invalidateQueries({
      queryKey: ['cloudUserData']
    });
  };
  const handleDeleteRecentToken = async (tokenToDelete: any) => {
    if (!recentTokenData?.data?.recent_tokens || !tokenToDelete) {
      return;
    }
    const saved = recentTokenData?.data?.recent_tokens.filter((token: any) => token.address !== tokenToDelete.address);
    await updateDbCloudWallet({
      eth_address: PKP?.ethAddress,
      recent_tokens: JSON.stringify(saved)
    });
    queryClient.invalidateQueries({
      queryKey: ['cloudUserData']
    });
  };
  const handleClearRecentTokens = async () => {
    if (!recentTokenData?.data?.recent_tokens) {
      return;
    }
    await updateDbCloudWallet({
      eth_address: PKP?.ethAddress,
      recent_tokens: JSON.stringify([])
    });
    queryClient.invalidateQueries({
      queryKey: ['cloudUserData']
    });
  };
  const filteredTokens = recentTokenData?.data?.recent_tokens?.filter(x => !x?.token?.address?.includes('::'));
  const {
    data: dataWithPrices
  } = useMultiTokenData({
    tokens: filteredTokens?.map(recentToken => {
      return `${recentToken?.token?.address}:${recentToken?.token?.networkId}`;
    }),
    minMarketCap: 0
  });
  const resultsMap = new Map(dataWithPrices?.map(result => [`${result?.token?.address}:${result?.token?.networkId}`, result]));

  // We recreate the order of the recent tokens (the API call in useMultiTokenData doesn't guarantee the order)
  const orderedResults = recentTokenData?.data?.recent_tokens?.map(recentToken => {
    try {
      const key = `${recentToken?.token?.address}:${recentToken?.token?.networkId}`;
      return resultsMap.get(key);
    } catch (_) {
      return null;
    }
  }).filter(Boolean);
  return {
    handleSaveRecent,
    handleClearRecentTokens,
    handleDeleteRecentToken,
    recentTokenData: orderedResults ?? []
  };
};